module.exports = __webpack_public_path__ + "jingTai/img/three.ff5d60a6.png";